"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCabinType = exports.GoogleTagManager = void 0;
var page_meta_event_1 = require("./page_meta_event");
var cruise_search_event_1 = require("./cruise_search_event");
var availability_events_1 = require("./availability_events");
var product_detail_view_1 = require("./product_detail_view");
var success_view_1 = require("./success_view");
var cancel_checkout_1 = require("./cancel_checkout");
var add_to_cart_1 = require("./add_to_cart");
var remove_from_cart_1 = require("./remove_from_cart");
var booking_events_1 = require("./booking_events");
var booking_step_events_1 = require("./booking_step_events");
var lodash_1 = require("lodash");
var moment_1 = require("moment");
var backend_event_1 = require("../../backend_event");
var BOOK_LOCAL_STORAGE_KEY = 'tracking/eecpurchase';
var DATE_FORMAT = 'DD.MM.YYYY';
function planningIsAllowed(state) {
    if ((0, lodash_1.get)(state, 'booking.affiliate.isExpinetAgency', false)) {
        return false;
    }
    if ((0, lodash_1.get)(state, 'booking.general.cruise.shortTerm', false)) {
        return false;
    }
    var cruise = (0, lodash_1.get)(state, 'booking.general.cruise');
    if ((0, lodash_1.isNil)(cruise) ||
        (cruise.priceModel !== 'VARIO' &&
            cruise.priceModel !== 'VARIOAI' &&
            cruise.priceModel !== 'PAUSCHAL' &&
            cruise.priceModel !== 'PREMIUM' &&
            cruise.priceModel !== 'PREMIUMAI')) {
        return false;
    }
    var daysToCruiseStart = (0, moment_1.utc)(cruise.departure, DATE_FORMAT).diff((0, moment_1.utc)(), 'days');
    if ((daysToCruiseStart > 90 &&
        cruise.priceModel !== 'PREMIUM' &&
        cruise.priceModel !== 'PREMIUMAI') ||
        daysToCruiseStart < 4) {
        return false;
    }
    return true;
}
function newRouteChangeHandler(settings) {
    var handlePageMetaEvent = (0, page_meta_event_1.newPageMetaEventHandler)(settings.mapping);
    return function (mutation, state) {
        var pageMetaEvents = mutation.payload.from.path === mutation.payload.to.path
            ? []
            : handlePageMetaEvent(mutation, state);
        switch (mutation.payload.to.name) {
            case 'searchingCruiseDetails':
                if ((0, lodash_1.get)(mutation, 'payload.from.name', null) === 'searchingIndex') {
                    return __spreadArray(__spreadArray([], (0, cruise_search_event_1.handleCruiseSearchEvent)(mutation, state), true), pageMetaEvents, true);
                }
                return __spreadArray([], pageMetaEvents, true);
            case 'bookingPersons':
            case 'bookingCabinCategory':
            case 'bookingTransport':
            case 'bookingPax':
            case 'bookingInsurance':
            case 'bookingCheckout':
                if (mutation.payload.from.name === null ||
                    mutation.payload.from.name.startsWith('booking') === false) {
                    var index = (0, booking_step_events_1.findStepIndex)(mutation.payload.to.fullPath);
                    var steps = [];
                    for (var i = 0; i <= index; i++) {
                        steps = __spreadArray(__spreadArray([], steps, true), (0, booking_step_events_1.handleBookingStepCompleted)(mutation, state, i), true);
                    }
                    return __spreadArray(__spreadArray([], pageMetaEvents, true), steps, true);
                }
                return __spreadArray(__spreadArray([], pageMetaEvents, true), (0, booking_step_events_1.handleBookingStepCompleted)(mutation, state), true);
            case 'bookingSuccess':
                var bookingEvent = (0, booking_events_1.handleBookingEvents)(mutation, state);
                var events = __spreadArray(__spreadArray([], pageMetaEvents, true), bookingEvent, true);
                (0, backend_event_1.eecPurchase)(events);
                if (settings.storage !== undefined && planningIsAllowed(state)) {
                    settings.storage.setItem(BOOK_LOCAL_STORAGE_KEY, JSON.stringify(events));
                    return [];
                }
                return events;
        }
        return pageMetaEvents;
    };
}
var GoogleTagManager = (function () {
    function GoogleTagManager(sender, settings) {
        if (settings === void 0) { settings = { mapping: page_meta_event_1.mapping }; }
        var _this = this;
        this.sender = sender;
        this.settings = settings;
        this.mutationToHandler = {
            'route/ROUTE_CHANGED': newRouteChangeHandler(this.settings),
            'searching/search/SET_NUM_FILTERED_RESULTS': function (mutation, state) {
                if (mutation.payload.length === 0 &&
                    (0, lodash_1.get)(state, 'route.from.name', null) === 'searchingIndex' &&
                    (0, lodash_1.get)(state, 'route.name', null) === 'searchingIndex') {
                    return (0, cruise_search_event_1.handleCruiseSearchEvent)(mutation, state);
                }
                return [];
            },
            'searching/search/SEARCH_BUTTON_TOUCHED': function (mutation, state) {
                if ((0, lodash_1.get)(state, 'route.from.name', null) === 'searchingIndex' &&
                    (0, lodash_1.get)(state, 'route.name', null) === 'searchingIndex') {
                    return __spreadArray(__spreadArray([], (0, cruise_search_event_1.handleCruiseSearchEvent)(mutation, state), true), (0, page_meta_event_1.newPageMetaEventHandler)(_this.settings.mapping)({
                        type: 'route/ROUTE_CHANGED',
                        payload: {
                            from: {
                                name: 'searchingIndex',
                                path: '/finden',
                                fullPath: '/finden',
                            },
                            to: {
                                name: 'searchingIndex',
                                path: '/finden/',
                                fullPath: '/finden/?adults=2',
                            },
                        },
                    }, state), true);
                }
                return [];
            },
            'searching/cruises/SET_SELECTED_CRUISE': availability_events_1.handleAvailabilityEvents,
            'searching/cruises/SET_CABIN': cruise_search_event_1.handleCruiseDetailsEvent,
            'planning/shop/TRACK_CHECKOUT': success_view_1.handleSuccessView,
            'planning/shop/TRACK_ADD_TO_CART': add_to_cart_1.handleAddToCart,
            'planning/shop/TRACK_REMOVE_FROM_CART': remove_from_cart_1.handleRemoveFromCart,
            'planning/shopItem/ADD_ITEM_DETAILS': product_detail_view_1.handleProductDetailView,
            'planning/shop/TRACK_CANCEL_CHECKOUT': cancel_checkout_1.handleCancelCheckoutView,
        };
        if (settings.storage) {
            var eventData = settings.storage.getItem(BOOK_LOCAL_STORAGE_KEY);
            if (eventData !== null) {
                var events = JSON.parse(eventData);
                for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
                    var event_1 = events_1[_i];
                    this.sender(event_1);
                }
            }
            settings.storage.removeItem(BOOK_LOCAL_STORAGE_KEY);
        }
    }
    GoogleTagManager.prototype.onStateChange = function (mutation, state) {
        var f = this.mutationToHandler[mutation.type];
        if (f) {
            for (var _i = 0, _a = f(mutation, state); _i < _a.length; _i++) {
                var event_2 = _a[_i];
                this.sender(event_2);
            }
        }
    };
    return GoogleTagManager;
}());
exports.GoogleTagManager = GoogleTagManager;
function getCabinType(state) {
    var stateCabins = state.planning.shop.bookingData.cabins;
    var groupedCabins = (0, lodash_1.groupBy)(stateCabins, function (c) { return c.sailingRPH; });
    var isCompoundCruise = Object.keys(groupedCabins || {}).length > 1;
    var types = '';
    (0, lodash_1.forEach)(groupedCabins || [], function (cabins) {
        var cabinTypes = cabins
            .map(function (cabin) { return cabin.cabinCategory; })
            .join('/');
        if (isCompoundCruise) {
            cabinTypes = "(".concat(cabinTypes, ")");
        }
        types = types.length > 0 ? "".concat(types, "/").concat(cabinTypes) : "".concat(cabinTypes);
    });
    return types;
}
exports.getCabinType = getCabinType;
//# sourceMappingURL=index.js.map